import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { RoomTypeModel } from 'types/api'

export function useCreateRoomType() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function createRoomType(args: RoomTypeModel) {
    const res = await apiClient.post<RoomTypeModel>(
      SNA_PREFIX + `room-types/`,
      args
    )
    return res.data
  }

  return useMutation({
    mutationFn: createRoomType,
    onSuccess: () => {
      toast.success({ message: t('roomTypeCreated') })
      queryClient.invalidateQueries({ queryKey: ['rooms'] })
    },
    onError // Updated to use useOnError
  })
}
